
export const ServiceError = {
    200400: "登录状态已失效",
    300000: "请先登录",
}